//angular imports
import {
    ChangeDetectionStrategy,
    Component, 
    WritableSignal, 
    signal,
} from '@angular/core';

//local imports
import { PresenterType } from '@shared/components';
import { RoomNotFoundMessage } from './room-not-found.message';

@PresenterType(
{
    model: RoomNotFoundMessage
})
@Component({
    selector: 'room-not-found-message-template',
    templateUrl: './room-not-found-message-template.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class RoomNotFoundMessageTemplateComponent
{
    public data: WritableSignal<RoomNotFoundMessage>;
    
    constructor() {
        this.data = signal<RoomNotFoundMessage>(null);
    }
}